import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
// import { VotosDistritoComponent } from './votos-distrito/componentes/votos-distrito/votos-distrito.component';
import { ResumenDistritoComponent } from '../diputacion/votos-distrito/componentes/resumen-distrito/resumen-distrito.component';
// import { DistritoCircunscripcionComponent } from './votos-distrito/componentes/distrito-circunscripcion/distrito-circunscripcion.component';
// import { DistritoEntidadComponent } from './votos-distrito/componentes/distrito-entidad/distrito-entidad.component';
import { DistritoDistritoComponent } from '../diputacion/votos-distrito/componentes/distrito-distrito/distrito-distrito.component';
import { ResumenDistritoMapaComponent } from '../diputacion/votos-distrito/componentes/resumen-distrito-mapa/resumen-distrito-mapa.component';
import { SeccionResumenComponent } from '../diputacion/seccion/seccion-resumen/seccion-resumen.component';
// import { CasillaResumenComponent } from './casilla/casilla-resumen/casilla-resumen.component';
// import { DistritoCircunscripcionMapaComponent } from './votos-distrito/componentes/distrito-circunscripcion-mapa/distrito-circunscripcion-mapa.component';
// import { DistritoEntidadMapaComponent } from './votos-distrito/componentes/distrito-entidad-mapa/distrito-entidad-mapa.component';
import { DistritoEntidadDetalleCasillaComponent } from '../diputacion/votos-distrito/componentes/distrito-entidad-detalle-casilla/distrito-entidad-detalle-casilla.component';
import { DistritoSeccionesComponent } from '../diputacion/votos-distrito/componentes/distrito-secciones/distrito-secciones.component';
import { VotosAnticipadosGobComponent } from '../gubernatura/votos-anticipados/votos-anticipados-gob.component';
import { VotosAnticipadosDetalleComponent } from '../gubernatura/votos-anticipados/votos-anticipados-detalle.component';
import { VotosPreventivosGobComponent } from '../gubernatura/votos-preventivos/votos-preventivos-gob.component';
import { VotosPreventivosDetalleComponent } from '../gubernatura/votos-preventivos/votos-preventivos-detalle.component';
import { VotosAnticipadosComponent } from '../../componentes/paginas/generales/votos-anticipados/votos-anticipados.component';
import { VotosPreventivosComponent } from '../../componentes/paginas/generales/votos-preventivos/votos-preventivos.component';

// import { ResumenPartidoGraficaComponent } from './votos-partido/componentes/resumen-partido-grafica/resumen-partido-grafica.component';
// import { ResumenPartidoComponent } from './votos-partido/componentes/resumen-partido/resumen-partido.component';
import { AuthGuard } from '../../auth/auth.guard';
import { ContiendasComponent } from '../contiendas.component';
import { CasillaResumenComponent } from '../diputacion/casilla/casilla-resumen/casilla-resumen.component';

const routes: Routes = [
  {
    path: 'ayuntamientos',
    canActivate: [AuthGuard],
    component: ContiendasComponent,
    children: [
      {
        path: '',
        redirectTo: 'votos-municipio',
        pathMatch: 'full',
      },
      {
        path: 'votos-municipio',
        children: [
          {
            path: '',
            redirectTo: 'mapa',
            pathMatch: 'full'
          },
          {
            path: 'mapa',
            component: ResumenDistritoMapaComponent,
            data : { contienda : 'Municipios'}
          },
          {
            path: 'tarjetas',
            component: ResumenDistritoComponent,
            data : { contienda : 'Municipios'}
          },
        ]
      },
      {
        path: ':municipio/votos-candidatura',
        component: DistritoDistritoComponent,
        data : { contienda : 'Municipios', contienda_s : 'Municipio', candidatura: true }
      },
      {
        path: ':distrito/detalle-casilla',
        component: DistritoEntidadDetalleCasillaComponent,
      },
      {
        path: ':distrito/secciones',
        component: DistritoSeccionesComponent,
        data : { contienda : 'Municipios', contienda_s : 'Municipio' }
      },
      {
        path: ':distrito/secciones/:seccion',
        component: SeccionResumenComponent,
      },
      {
        path: ':distrito/secciones/:seccion/casilla/:casilla',
        component: CasillaResumenComponent,
      },
      {
        path: ':distrito/votos-anticipados',
        component: VotosAnticipadosGobComponent
        //,data : { contienda : 'Distritos', contienda_s : 'Distrito' }
      },
      {
        path: ':distrito/votos-preventivos',
        component: VotosPreventivosGobComponent
        //,data : { contienda : 'Distritos', contienda_s : 'Distrito' }
      },
      {
        path: 'votos-anticipados/mesa/:mesa',
        component: VotosAnticipadosDetalleComponent
        //,data : { contienda : 'Distritos', contienda_s : 'Distrito' }
      },
      {
        path: 'votos-preventivos/mesa/:mesa',
        component: VotosPreventivosDetalleComponent
        //,data : { contienda : 'Distritos', contienda_s : 'Distrito' }
      },
      {
        path: 'votos-anticipados',
        component: VotosAnticipadosComponent
        //,data : { contienda : 'Distritos', contienda_s : 'Distrito' }
      },
      {
        path: 'votos-preventivos',
        component: VotosPreventivosComponent
        //,data : { contienda : 'Distritos', contienda_s : 'Distrito' }
      },
      // {
      //   path: ':distrito/secciones/:seccion/casilla/:casilla',
      //   component: CasillaResumenComponent,
      // },
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AyuntamientoCandidaturaRoutingModule { }
